import { Alert } from 'react-bootstrap';
import usePlan from '../hooks/usePlan';

/** Tells people when the month's document allowance is nearly or fully used. Silent while there is plenty left. */
function AllowanceBanner() {
  const { usage, plan } = usePlan();
  const state = usage?.monthlyDocumentState;
  if (!state || state === 'OK' || state === 'UNLIMITED') return null;

  const used = usage.monthlyDocumentCount;
  const allowance = usage.monthlyDocumentAllowance;
  const grace = usage.monthlyDocumentGraceLimit;
  const resets = usage.monthlyDocumentsResetOn;
  const name = plan?.name ? `${plan.name} plan` : 'plan';

  if (state === 'WARNING') {
    return (
      <div className="container-fluid pt-3"><Alert variant="info" className="py-2 small mb-0">
        You have used {used} of this month&apos;s {allowance} documents on your {name}. Counts reset on {resets}.
      </Alert></div>
    );
  }
  if (state === 'OVER') {
    return (
      <div className="container-fluid pt-3"><Alert variant="warning" className="py-2 small mb-0">
        You are over this month&apos;s allowance ({used} of {allowance}). You can keep working for another {Math.max(grace - used, 0)} documents;
        after that new documents pause until {resets}. Ask your administrator to upgrade the plan or add a top-up.
      </Alert></div>
    );
  }
  return (
    <div className="container-fluid pt-3"><Alert variant="danger" className="py-2 small mb-0">
      This month&apos;s document allowance is used up ({used} of {allowance}, plus a 10% grace). New documents are paused until {resets}.
      Ask your administrator to upgrade the plan or add a top-up.
    </Alert></div>
  );
}

export default AllowanceBanner;
